var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-autocomplete-item"},[_c('div',{staticClass:"el-autocomplete-item__text-wrap"},[_c('p',[_vm._v(_vm._s(_vm.item.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }